define('directives/cancellation/cancellation',[
	'app',
	'settings',
	'services/PaymentMethodService',
	'services/ValidationService',
	'services/CancellationService',
	'services/NotificationService',
], function (app) {
	'use strict';
	app.directive('ngCancellation', [
		'BASE_DIRECTIVES_PATH',
		function (BASE_DIRECTIVES_PATH) {
			return {
				scope: {
					cancellation: '=?',
					shopOrder: '=',
					onFinish: '&',
				},
				templateUrl: BASE_DIRECTIVES_PATH + '/cancellation/views/cancellation.html',
				controller: [
					'$scope',
					'PaymentMethodService',
					'ValidationService',
					'CancellationService',
					'NotificationService',
					function (
						$scope,
						PaymentMethodService,
						ValidationService,
						CancellationService,
						NotificationService
					) {
						PaymentMethodService.findAll(true).then(function () {
							$scope.paymentMethods = PaymentMethodService.getAll();
						});

						// Define cancellation reason options
						$scope.reasonOptions = [
							{display:'CANCELATION.DOES_NOT_LIKE_ARTICLE', value:'DOES_NOT_LIKE_ARTICLE'},
							{display:'CANCELATION.DELIVERY_TIME_TOO_LONG', value:'DELIVERY_TIME_TOO_LONG'},
							{display:'CANCELATION.QUALITY_INADEQUATE', value:'QUALITY_INADEQUATE'},
							{display:'CANCELATION.ARTICLE_DOES_NOT_MATCH_PICTURE', value:'ARTICLE_DOES_NOT_MATCH_PICTURE'},
							{display:'CANCELATION.CUSTOMER_ERROR_ON_ORDER', value:'CUSTOMER_ERROR_ON_ORDER'},
							{display:'CANCELATION.OTHER', value:'OTHER'}
						];

						// Define cancellation handling options
						$scope.handlingOptions = [
							{display:'CANCELATION.REFUND', value:'REFUND'},
							{display:'CANCELATION.CREDIT', value:'CREDIT'},
							{display:'CANCELATION.NOT_PAID_YET', value:'NOT_PAID_YET'}
						];

						$scope.createCancellation = function () {
							console.log('=== CREATE CANCELLATION CALLED ===');
							console.log('Original cancellation object:', JSON.stringify($scope.cancellation));

							// Prepare DTO for backend - extract only values from reason and handling BEFORE validation
							var cancellationDTO = angular.copy($scope.cancellation);

							// Convert reason and handling from objects to strings BEFORE validation
							if (cancellationDTO.reason && typeof cancellationDTO.reason === 'object') {
								console.log('Converting reason from object:', cancellationDTO.reason);
								cancellationDTO.reason = cancellationDTO.reason.value || cancellationDTO.reason;
								console.log('Converted reason to string:', cancellationDTO.reason);
							}
							if (cancellationDTO.handling && typeof cancellationDTO.handling === 'object') {
								console.log('Converting handling from object:', cancellationDTO.handling);
								cancellationDTO.handling = cancellationDTO.handling.value || cancellationDTO.handling;
								console.log('Converted handling to string:', cancellationDTO.handling);
							}

							var validationObj = {
								reason: {
									method: 'isset',
									fieldName: 'Grund',
								},
								handling: {
									method: 'isset',
									fieldName: 'Bearbeitung',
								},
							};

							// Validate the converted DTO instead of the original scope object
							if (!ValidationService.validate(cancellationDTO, validationObj)) {
								$scope.validationErrors = ValidationService.getErrors();
								console.error('Validation failed:', $scope.validationErrors);
								return;
							}

							if (!cancellationDTO.id) {
								// Optional warning if refundMethodId is missing for REFUND
								if (!cancellationDTO.refundMethodId &&
								    (cancellationDTO.handling === 'REFUND' || cancellationDTO.handling === 'DEPOSIT_REFUND')) {
									console.warn('Warning: No refund method selected for REFUND handling');
								}

								console.log('Sending cancellation DTO to backend:', JSON.stringify(cancellationDTO));

								//create new cancellation
								CancellationService.create(cancellationDTO).then(function (response) {
									console.log('Cancellation created successfully:', response);
									if (response.ok !== false) {
										NotificationService.notifySuccess({
											statusText: 'Die ausgewählten Positionen wurden erfolgreich storniert.',
										});
										$scope.onFinish();
									} else {
										NotificationService.notifyGeneralError({
											statusText:
												'Es ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal.',
										});
										$scope.onFinish();
									}
								}).catch(function(error) {
									console.error('Cancellation error:', error);
									console.error('Error data:', error.data);
									console.error('Error status:', error.status);
									console.error('Error statusText:', error.statusText);
									var errorMsg = 'Fehler bei der Stornierung: ';
									if (error.data && error.data.message) {
										errorMsg += error.data.message;
									} else if (error.statusText) {
										errorMsg += error.statusText;
									} else {
										errorMsg += 'Unbekannter Fehler';
									}
									NotificationService.notifyGeneralError({
										statusText: errorMsg,
									});
								});
							} else {
								console.log('Update of a cancellation is not allowed.');
							}
						};
					},
				],
			};
		},
	]);
});

